import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';
import EmptyMessage from 'src/components/emptyMessage';

interface PermissionDeninedProps {
  className?: string;
}

const PermissionDenined: React.FC<PermissionDeninedProps> = ({ className }) => {
  return (
    <div className={cx(styles.container, className)}>
      <EmptyMessage
        width="auto"
        image={'/images/no_access.svg'}
        heading="No access!"
        message="Oops! You do not have access to this module."
      />
    </div>
  );
};

export default PermissionDenined;